import { ButtonType } from "flavr-common";
import { SetControllerButtonActionsMessage } from "@messages/interaction/InteractionMessages";
import { inputActionService } from "@modules/inputs/input/InputActionService";
import { inputService } from "@modules/inputs/input/InputService";
import { scriptService } from "../services/ScriptService";
const scriptActionSubscriptions = new Map();
export class ScriptInput {
    static subscribeAction(actionName, callback) {
        inputActionService.subscribeAction(actionName, callback);
        if (scriptService.context && scriptService.context.currentScriptIdx !== undefined) {
            const script = scriptService.context.currentScript;
            if (script) {
                const func = () => {
                    this.unsubscribeAction(callback);
                };
                script.onDestroyDelegate.add(func);
                scriptActionSubscriptions.set(scriptService.context.currentScriptIdx, func);
            }
        }
    }
    static unsubscribeAction(callback) {
        inputActionService.unsubscribeAction(callback);
        if (scriptService.context && scriptService.context.currentScriptIdx !== undefined) {
            scriptActionSubscriptions.delete(scriptService.context.currentScriptIdx);
        }
    }
    static subscribeAxis(axisName, callback) {
        inputActionService.subscribeAxis(axisName, callback);
        if (scriptService.context && scriptService.context.currentScriptIdx !== undefined) {
            const script = scriptService.context.currentScript;
            if (script) {
                const func = () => {
                    this.unsubscribeAxis(callback);
                };
                script.onDestroyDelegate.add(func);
            }
        }
    }
    static unsubscribeAxis(callback) {
        inputActionService.unsubscribeAxis(callback);
    }
    static pressKey(keyName, modifiers) {
        return inputService.emulateKeyPress(keyName, modifiers);
    }
    static disableDefaultButtonActions() {
        if (!scriptService.context)
            return;
        const messages = [];
        messages.push(new SetControllerButtonActionsMessage(ButtonType.CLICK, {
            onClick: undefined,
            onDoubleClick: undefined,
            onHold: undefined,
            onHoldReleased: undefined
        }));
        messages.push(new SetControllerButtonActionsMessage(ButtonType.DISCARD, {
            onClick: undefined,
            onDoubleClick: undefined,
            onHold: undefined,
            onHoldReleased: undefined
        }));
        scriptService.context.connection.sendMultiple(messages);
    }
}
